// Web-only i18n resources.
//
// The marketing site (apps/web) only ever renders the `common` and `web`
// namespaces. Importing the full `bundledResources` (which statically pulls in
// desktop.json ~28KB + api.json) shipped ~60KB of dead translation JSON to the
// browser. This module imports ONLY what the web bundle needs, so the desktop
// and api namespaces tree-shake out of the client bundle entirely.
//
// Kept in its own module (no `sharedI18n` side effect, no desktop/api imports)
// so consumers can pull it without dragging the rest of the i18n graph in.

import { I18N_NAMESPACES } from './namespaces.js'

import enCommon from './locales/en/common.json' with { type: 'json' }
import enWeb from './locales/en/web.json' with { type: 'json' }
import zhTWCommon from './locales/zh-TW/common.json' with { type: 'json' }
import zhTWWeb from './locales/zh-TW/web.json' with { type: 'json' }

/** Namespaces the web app loads — `common` + `web` only. */
export const WEB_NAMESPACES = [I18N_NAMESPACES.common, I18N_NAMESPACES.web] as const

/** Bundled translations for the web app, scoped to its two namespaces. */
export const webBundledResources = {
  en: {
    [I18N_NAMESPACES.common]: enCommon,
    [I18N_NAMESPACES.web]: enWeb,
  },
  'zh-TW': {
    [I18N_NAMESPACES.common]: zhTWCommon,
    [I18N_NAMESPACES.web]: zhTWWeb,
  },
} as const
